import React from 'react';
import ReactDOM from 'react-dom';
import { AccountTab } from './view/Account/AccountTab';
import { Tabs } from 'antd';
import { MyDataHandler } from './handler/MyDataHandler';
import { MyViewsTab } from './view/MyViews/MyViewsTab';
import { FlyoutContent } from './FlyoutContent';
import { PublishedMapsHandler } from './handler/PublishedMapsHandler';
import { MyViewsHandler } from './handler/MyViewsHandler';
import { PublishedMapsTab } from './view/PublishedMaps/PublishedMapsTab';
import { LocaleProvider, ThemeProvider } from 'oskari-ui/util';
import './service/MyDataService';

/**
 * @class Oskari.mapframework.bundle.mydata.Flyout
 */
Oskari.clazz.define('Oskari.mapframework.bundle.mydata.Flyout',
/**
 * @method create called automatically on construction
 * @static
 * @param {Oskari.mapframework.bundle.mydata.MyDataBundleInstance} instance
 *     reference to component that created the flyout
 */

function (instance) {
  var _this = this;
  this.instance = instance;
  this.container = null;
  this.state = null;
  this.uiHandler = new MyDataHandler(function () {
    return _this.update();
  });
  this.myDataService = null;
}, {
  /**
   * @method getName
   * @return {String} the name for the component
   */
  getName: function getName() {
    return 'Oskari.mapframework.bundle.mydata.Flyout';
  },
  /**
   * @method setEl
   * @param {Object} el
   *     reference to the container in browser
   * @param {Number} width
   *     container size(?) - not used
   * @param {Number} height
   *     container size(?) - not used
   *
   * Interface method implementation
   */
  setEl: function setEl(el, flyout, width, height) {
    this.container = el[0];
    if (!jQuery(this.container).hasClass('mydata')) {
      jQuery(this.container).addClass('mydata');
    }
    if (!flyout.hasClass('mydata')) {
      flyout.addClass('mydata');
    }
  },
  /**
   * @method startPlugin
   *
   * Interface method implementation, assigns the HTML templates that will be used to create the UI
   */
  startPlugin: function startPlugin() {
    if (Oskari.user().isLoggedIn()) {
      this.myDataService = Oskari.clazz.create('Oskari.mapframework.bundle.mydata.service.MyDataService', this.uiHandler);
      Oskari.getSandbox().registerService(this.myDataService);
      if (this.instance.conf && this.instance.conf.showUser) {
        this.myDataService.addTab('account', Oskari.getMsg('MyData', 'tabs.account.title'), AccountTab, {
          getState: function getState() {
            return {
              user: Oskari.user(),
              changeInfoUrl: Oskari.urls.getLocation('profile')
            };
          },
          getController: function getController() {
            return null;
          },
          addStateListener: function addStateListener() {
            return null;
          }
        });
      }
      if (this.instance.conf && this.instance.conf.showViews) {
        this.myDataService.addTab('myviews', Oskari.getMsg('MyData', 'tabs.myviews.title'), MyViewsTab, new MyViewsHandler(this.instance));
      }
      this.myDataService.addTab('publishedmaps', Oskari.getMsg('MyData', 'tabs.publishedmaps.title'), PublishedMapsTab, new PublishedMapsHandler(this.instance));
    }
    this.update();
  },
  /**
   * @method stopPlugin
   *
   * Interface method implementation, does nothing atm
   */
  stopPlugin: function stopPlugin() {},
  /**
   * @method getTitle
   * @return {String} localized text for the title of the flyout
   */
  getTitle: function getTitle() {
    return this.instance.getLocalization('title');
  },
  /**
   * @method getDescription
   * @return {String} localized text for the description of the flyout
   */
  getDescription: function getDescription() {
    return this.instance.getLocalization('desc');
  },
  /**
   * @method getOptions
   * Interface method implementation, does nothing atm
   */
  getOptions: function getOptions() {},
  /**
   * @method setState
   * @param {Object} state
   *     state that this component should use
   * Interface method implementation, does nothing atm
   */
  setState: function setState(state) {
    this.state = state;
  },
  update: function update() {
    var _this2 = this;
    var flyout = jQuery(this.container);
    var _this$uiHandler$getSt = this.uiHandler.getState(),
      tabs = _this$uiHandler$getSt.tabs,
      activeTab = _this$uiHandler$getSt.activeTab;
    ReactDOM.render(/*#__PURE__*/React.createElement(LocaleProvider, {
      value: {
        bundleKey: 'MyData'
      }
    }, /*#__PURE__*/React.createElement(ThemeProvider, null, /*#__PURE__*/React.createElement(FlyoutContent, {
      loginStatus: this.getLoginStatus()
    }, /*#__PURE__*/React.createElement(Tabs, {
      activeKey: activeTab,
      onChange: function onChange(tab) {
        return _this2.uiHandler.setActiveTab(tab);
      },
      items: tabs.map(function (t) {
        return {
          key: t.id,
          label: /*#__PURE__*/React.createElement("span", {
            className: 't_tab t_' + t.id
          }, t.title),
          children: /*#__PURE__*/React.createElement(t.component, {
            state: t.handler.getState(),
            controller: t.handler.getController()
          })
        };
      })
    })))), flyout[0]);
  },
  /**
   * @method createUi
   * Creates the UI for a fresh start
   */
  createUi: function createUi() {
    this.update();
    this.addProfileLink();
  },
  addProfileLink: function addProfileLink() {
    var _this3 = this;
    jQuery('#oskari-profile-link').on('click', function () {
      _this3.openProfileTab();
      return false;
    });
  },
  openProfileTab: function openProfileTab() {
    Oskari.getSandbox().postRequestByName('userinterface.UpdateExtensionRequest', [this.instance, 'attach']);
    this.uiHandler.setActiveTab('account');
  },
  /**
   * @method getLoginUrl
   * @returns {String}
   */
  getLoginStatus: function getLoginStatus() {
    var conf = this.instance.conf || {};
    return {
      loggedIn: Oskari.user().isLoggedIn(),
      loginUrl: Oskari.getLocalized(conf.logInUrl) || Oskari.urls.getLocation('login'),
      registerUrl: Oskari.urls.getLocation('register')
    };
  }
}, {
  /**
   * @property {String[]} protocol
   * @static
   */
  'protocol': ['Oskari.userinterface.Flyout']
});